import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  adjustItemQty,
  loadCurrentItem,
  removeFromCart,
} from "../../../redux/ecommerce/ecommerceActions";

import {
  Button,
  Row,
  Col,
  Divider,
  Tag,
  InputNumber,
  Empty,
  Avatar,
} from "antd";
import { ShoppingBag } from "iconsax-react";

import EmptyImage from "../../../assets/images/apps/ecommerce/checkout-empty.svg";

export default function HeaderCart() {
  // Basket Dropdwon
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.ecommerce.cart);
  const [totalItem, setTotalItem] = useState(0);

  useEffect(() => {
    let items = 0;

    cart.forEach((item) => {
      items += item.qty;
    });

    setTotalItem(items);
  }, [cart, totalItem, setTotalItem]);

  // Basket Qty
  const onChangeHandler = (e, id) => {
    dispatch(adjustItemQty(id, e));
  };

  // Remove Cart
  const [removeClass, setRemoveClass] = useState("");

  const handleClick = () => {
    setRemoveClass("remove-cart");

    setTimeout(() => {
      setRemoveClass("");
    }, 200);
  };

  return (
    <Col className="hp-d-flex-center hp-mr-8 hp-basket-dropdown-button">
      <Button
        ghost
        className="hp-border-none hp-hover-bg-black-10 hp-hover-bg-dark-100"
        icon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.6249 9.37598V13.751C10.6249 13.9167 10.559 14.0757 10.4418 14.1929C10.3246 14.3101 10.1656 14.376 9.99989 14.376C9.83413 14.376 9.67516 14.3101 9.55795 14.1929C9.44074 14.0757 9.37489 13.9167 9.37489 13.751V9.37598C9.37489 9.21022 9.44074 9.05124 9.55795 8.93403C9.67516 8.81682 9.83413 8.75098 9.99989 8.75098C10.1656 8.75098 10.3246 8.81682 10.4418 8.93403C10.559 9.05124 10.6249 9.21022 10.6249 9.37598ZM18.739 7.66582L17.6561 15.7916C17.616 16.0919 17.4681 16.3674 17.2401 16.5669C17.012 16.7663 16.7193 16.8762 16.4163 16.876H3.58348C3.2805 16.8762 2.98776 16.7663 2.7597 16.5669C2.53164 16.3674 2.38378 16.0919 2.34364 15.7916L1.26004 7.6666C1.23643 7.48996 1.25086 7.31031 1.30237 7.1397C1.35388 6.96909 1.44127 6.81147 1.55869 6.6774C1.67611 6.54334 1.82083 6.43593 1.98316 6.36238C2.14549 6.28884 2.32167 6.25085 2.49989 6.25098H5.3413L9.53114 1.46426C9.58979 1.39775 9.66192 1.34449 9.74274 1.30801C9.82356 1.27152 9.91122 1.25266 9.99989 1.25266C10.0886 1.25266 10.1762 1.27152 10.257 1.30801C10.3379 1.34449 10.41 1.39775 10.4686 1.46426L14.6585 6.25098H17.4999C17.6779 6.25109 17.8538 6.28922 18.0159 6.36282C18.178 6.43642 18.3225 6.54378 18.4397 6.67773C18.5569 6.81168 18.6442 6.96913 18.6957 7.13953C18.7472 7.30993 18.7616 7.48937 18.7382 7.66582H18.739ZM7.00223 6.25098H12.9975L9.99989 2.82519L7.00223 6.25098ZM17.4999 7.50098H2.49989L3.58348 15.626H16.4163L17.4999 7.50098ZM13.503 9.31347L13.0655 13.6885C13.0569 13.7704 13.0645 13.8532 13.088 13.9322C13.1114 14.0111 13.1503 14.0846 13.2023 14.1485C13.2542 14.2124 13.3183 14.2654 13.3909 14.3044C13.4634 14.3435 13.5429 14.3678 13.6249 14.376C13.646 14.3771 13.6671 14.3771 13.6882 14.376C13.843 14.3758 13.9922 14.3181 14.1069 14.2142C14.2217 14.1103 14.2938 13.9675 14.3093 13.8135L14.7468 9.43848C14.7633 9.27354 14.7137 9.10878 14.6088 8.98044C14.5039 8.85209 14.3523 8.77068 14.1874 8.7541C14.0225 8.73752 13.8577 8.78715 13.7294 8.89205C13.601 8.99695 13.5196 9.14854 13.503 9.31347ZM6.49676 9.31347C6.48019 9.14854 6.39877 8.99695 6.27043 8.89205C6.14208 8.78715 5.97732 8.73752 5.81239 8.7541C5.64746 8.77068 5.49587 8.85209 5.39096 8.98044C5.28606 9.10878 5.23644 9.27354 5.25301 9.43848L5.69051 13.8135C5.70606 13.9682 5.77871 14.1115 5.89428 14.2155C6.00985 14.3196 6.16003 14.3768 6.31551 14.376C6.33659 14.3771 6.35772 14.3771 6.3788 14.376C6.46046 14.3678 6.53971 14.3436 6.61202 14.3047C6.68433 14.2659 6.74828 14.2132 6.80022 14.1496C6.85217 14.0861 6.89108 14.0129 6.91475 13.9343C6.93842 13.8558 6.94638 13.7733 6.93817 13.6916L6.49676 9.31347Z"
              fill="#636E72"
            />
          </svg>
        }
      />

      <div className={`hp-basket-dropdown ${removeClass}`}>
        <Row gutter={[8, 8]} align="middle" justify="space-between">
          <Col>
            <h5 className="hp-mb-0 hp-text-color-dark-15">My Cart</h5>
          </Col>

          {cart.length !== 0 && (
            <Col>
              <span className="hp-caption hp-font-weight-500 hp-text-color-black-80 hp-text-color-dark-30">
                {totalItem}

                {cart.length === 1 ? " Item" : " Items"}
              </span>
            </Col>
          )}
        </Row>

        <Divider className="hp-mb-4 hp-mt-0" />

        <div className="hp-basket-dropdown-list">
          {cart.length !== 0 ? (
            cart.map((value, index) => (
              <div key={value.id}>
                <div
                  className="hp-d-block hp-transition hp-hover-bg-primary-4 hp-hover-bg-dark-80 hp-border-radius hp-py-8 hp-px-10 hp-overflow-x-auto"
                  style={{ marginLeft: -10, marginRight: -10 }}
                >
                  <Row align="middle" justify="space-between" wrap={false}>
                    <Col
                      flex="1 0 0"
                      className="hp-basket-dropdown-list-item-title"
                    >
                      <Row wrap={false}>
                        <Col flex="0 0 32px" className="hp-mt-4">
                          <Link
                            to={`/apps/ecommerce/product-detail/${value.id}`}
                            onClick={() => dispatch(loadCurrentItem(value))}
                          >
                            <Avatar
                              size={35}
                              src={require(`../../../assets/images/product/${value.imgList}`)}
                              className="hp-bg-black-0 hp-bg-dark-100"
                            />
                          </Link>
                        </Col>

                        <Col flex="0 0 110px" className="hp-ml-10">
                          <Link
                            to={`/apps/ecommerce/product-detail/${value.id}`}
                            onClick={() => dispatch(loadCurrentItem(value))}
                          >
                            <h5
                              className="hp-mb-0 hp-font-weight-400 hp-p1-body hp-text-color-black-100 hp-text-color-dark-15"
                              style={{ lineHeight: 1.2 }}
                            >
                              {value.title}
                            </h5>

                            <p
                              className="hp-mb-0 hp-caption hp-text-color-black-60"
                              style={{ marginTop: 1 }}
                            >
                              By{" "}
                              <span className="hp-text-color-black-80">
                                {value.person}
                              </span>
                            </p>
                          </Link>
                        </Col>

                        <Col
                          flex="0 0 90px"
                          className="hp-d-flex hp-d-flex-column hp-ml-18"
                        >
                          <InputNumber
                            min={1}
                            max={99}
                            value={value.qty}
                            onChange={(e) => onChangeHandler(e, value.id)}
                            style={{ width: 65, marginTop: 2 }}
                            size="small"
                          />

                          <div
                            className="hp-cursor-pointer hp-d-inline-block hp-mt-4 hp-input-description hp-font-weight-500 hp-text-color-black-60 hp-text-color-dark-60 hp-text-underline"
                            onClick={() => dispatch(removeFromCart(value.id))}
                          >
                            Remove Item
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col>
                      <p className="hp-basket-dropdown-list-item-price hp-p1-body hp-mb-0 hp-text-color-black-80 hp-text-color-dark-30 hp-font-weight-500 hp-slashed-zero">
                        {value.discount
                          ? "$" + value.discount
                          : "$" + value.price}
                      </p>
                    </Col>
                  </Row>
                </div>

                {cart.length != index + 1 && (
                  <Divider className="hp-my-4 hp-bg-color-dark-80" />
                )}
              </div>
            ))
          ) : (
            <Empty
              image={EmptyImage}
              imageStyle={{
                height: 100,
              }}
              description={<h5>Your cart is empty</h5>}
            />
          )}
        </div>

        <Divider className="hp-mt-4 hp-mb-0" />

        <Row gutter={[12]}>
          {cart.length !== 0 ? (
            <>
              <Col span={12}>
                <Link to="/apps/ecommerce/checkout" onClick={handleClick}>
                  <Button
                    block
                    type="text"
                    className="hp-bg-black-20 hp-text-color-black-100 hp-hover-text-color-primary-1 hp-hover-bg-primary-4"
                  >
                    View Cart
                  </Button>
                </Link>
              </Col>

              <Col span={12}>
                <Link
                  to="/apps/ecommerce/address-information"
                  onClick={handleClick}
                >
                  <Button
                    block
                    type="text"
                    className="hp-text-color-black-0 hp-bg-black-100 hp-hover-bg-primary-1"
                  >
                    Checkout
                  </Button>
                </Link>
              </Col>
            </>
          ) : (
            <Col span={24}>
              <Link to="/apps/ecommerce/shop" onClick={handleClick}>
                <Button
                  block
                  type="text"
                  className="hp-text-color-black-0 hp-bg-black-100 hp-hover-bg-primary-1"
                >
                  Go to shop list
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </div>
    </Col>
  );
}
